import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AllocationViewEndpoint } from '../../constants';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { CarrierModel } from '../../../../../../common/models';
import { getQueryStringFromObject } from '../../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class AllocationViewActionsCarriersService {
  constructor(private http: WrapperHttpService) {}
  getCarriers(filter: string, limit: number = 10): Observable<CarrierModel[]> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${AllocationViewEndpoint.WebUli}${AllocationViewEndpoint.Carriers}?` +
          getQueryStringFromObject({ filter, limit }),
      );
  }
}
